<template>
  <div>
    <v-row class="mt-50 pa-0">
      <v-col class="ma-0 pa-0">
        <h2 class="headline mt-8 font-weight-bold">
          <template v-if="developmentProjects"
            >Projects In Development/Construction</template
          >
          <template v-if="operationalProjects">Operational Projects</template>
        </h2>
        <v-data-table
          v-once
          v-for="(item, index) in allProjectTypeNames"
          :key="`${item}-${index}`"
          :items="facilities(item, status)"
          :headers="headers(item)"
          :sort-by.sync="sortBy"
          v-show="showHide(item, status)"
          @current-items="tableLoaded"
          :class="`${status}-table`"
          class="factsheet-data-table flat elevation-0 mb-4 pa-0"
          disable-pagination
          disable-filtering
          hide-default-footer
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="title">{{ item }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <!-- hidden items -->
          <template v-slot:header.status></template>
          <template v-slot:item.status></template>
          <template v-slot:header.image v-show="false"></template>
          <template v-slot:item.image v-show="false"></template>

          <!-- abbreviate state names -->
          <template v-slot:item.state="{ item }">
            {{ item.state | stateAbbr }}
          </template>

          <!-- show/hide district as required -->
          <template v-slot:header.district v-if="hideDistrict"></template>
          <template v-slot:item.district v-if="hideDistrict"></template>

          <template v-slot:no-data>No {{ item }} Data</template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import listConfig from '@/config/listConfig';
import appConfig from '@/config/appConfig';
import stateAbbrHelper from '@/helpers/StateAbbrHelper';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'FactsheetTable',
  props: ['status'],
  data() {
    return {
      energyTypes: listConfig.energyTypes,
      sortBy: listConfig.sortBy,
      hideDistrict: false,
      developmentProjects: false,
      operationalProjects: false
    };
  },
  computed: {
    ...mapGetters({
      filterStatus: 'filterData/mapFilterStatus',
      statusValues: 'filterData/statusValues',
      mapFilterEnergy: 'filterData/mapFilterEnergy',
      allProjects: 'tableData/allProjects',
      selectedItemType: 'mapTemplate/selectedItemType',
      selectedItemValue: 'mapTemplate/selectedItemValue'
    }),
    allProjectTypeNames: function () {
      let allProjectTypeNames = [];
      for (let key in this.allProjects) {
        //remove the Other group from the tables, was requested to include in.  Uncomment out if necessary to be removed again.
        // remove Unknown items
        //if (key !== 'Unknown') {
        allProjectTypeNames.push(key);
        //}
      }
      return allProjectTypeNames;
    }
  },
  methods: {
    facilities: function (item, status) {
      let currentFacilities;
      let selectedType = this.selectedItemType;
      let selectedValue = this.selectedItemValue;

      if (selectedValue === 'Global') {
        switch (status) {
          case 'operational':
            currentFacilities = this.allProjects[item].filter(
              (x) => x.status === 'Operational'
            );
            break;
          case 'development':
            currentFacilities = this.allProjects[item].filter(
              (x) => x.status === 'Development/Construction'
            );
            break;
          default:
            currentFacilities = this.allProjects[item];
            break;
        }
      } else {
        switch (status) {
          case 'operational':
            currentFacilities = this.allProjects[item].filter(
              (x) =>
                x.state.toUpperCase() === selectedValue.toUpperCase() &&
                x.status === 'Operational'
            );
            break;
          case 'development':
            currentFacilities = this.allProjects[item].filter(
              (x) =>
                x.state.toUpperCase() === selectedValue.toUpperCase() &&
                x.status === 'Development/Construction'
            );
            break;
          default:
            currentFacilities = this.allProjects[item].filter(
              (x) => x.state.toUpperCase() === selectedValue.toUpperCase()
            );
            break;
        }
      }
      return currentFacilities;
    },
    headers: function (item) {
      let currentItem = this.energyTypes.find((i) => i.name == item);
      // remove image column
      let currentHeaders = currentItem.headers.filter(
        (x) => x.value !== 'image'
      );
      return currentHeaders;
    },
    showHide(item, status) {
      if (
        this.facilities(item, status).length &&
        this.facilities(item, status).filter((x) => x.status == status)
      ) {
        if (status == 'development') {
          this.hasDevelopmentProjects = true;
        }
        return true;
      } else {
        if (status !== 'development') {
          this.hasDevelopmentProjects = false;
        }
        return false;
      }
    },
    filterItems(item, search, filter) {
      this.search = this.statusType;
      return item.filter((x) => x.status == search);
    },
    tableLoaded(currentItems) {
      // Hide District Column for Canada
      currentItems.forEach((x) => {
        if (x.country == 'Canada') {
          this.hideDistrict = true;
        } else {
          this.hideDistrict = false;
        }
        // Set num of operational and development projects
        if (this.status === 'operational') {
          this.operationalProjects++;
        }
        if (this.status === 'development') {
          this.developmentProjects++;
        }
      });
    }
  },
  filters: {
    stateAbbr: function (item) {
      return stateAbbrHelper.stateAbbr(item);
    }
  }
};
</script>

<style lang="scss">
// must not be scoped to have effect
.v-toolbar__title {
  color: $ne-textcolor;
}

.v-data-table.factsheet-data-table {
  width: 100%;
  page-break-inside: auto;
  .v-toolbar__content {
    padding-left: 0;
    align-items: flex-end;
  }
  &.operational-table,
  &.development-table {
    th {
      color: #fff !important;
    }
    td:first-child {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
  &.operational-table {
    .v-data-table-header {
      background-color: $ne-blue;
    }
  }
  &.development-table {
    .v-data-table-header {
      background-color: $ne-textcolor;
    }
  }

  tbody {
    tr {
      &:hover {
        background: none !important;
      }
      &:last-child {
        border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
      }
    }
    td {
      color: $ne-textcolor;
    }
  }

  .v-icon {
    display: none;
  }
}
</style>
